import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import "./style.css";

const useStyles = makeStyles({
  rootStateBlock: {
    marginTop: 16,
    marginBottom: 8,
    height: 20,
    display: "flex",
    flexDirection: "column",
    width: "240px",
    boxSizing: "border-box"
  }
});

export default function StateBlock({ leftChipLabel,
                                     rightChipLabel,
                                     leftChipBackground,
                                     rightChipBackground,
                                     leftChipIcon,
                                     rightChipIcon}) {
  const classes = useStyles();

  return (
    <div className={classes.rootStateBlock}>
      <Grid container direction="row" justify="space-between">
        {leftChipLabel &&
        <Grid item xs={!rightChipLabel ? 12 : 6}>
          <Chip
            color="primary"
            style={{ backgroundColor: leftChipBackground }}
            size="small"
            label={leftChipLabel}
            icon={leftChipIcon}
          />
        </Grid>}
        {rightChipLabel &&
        <Grid style={{textAlign: 'end'}} item xs={!leftChipLabel ? 12 : 6}>
          <Chip
            color="primary"
            style={{ backgroundColor: rightChipBackground }}
            size="small"
            icon={rightChipIcon}
            label={rightChipLabel}
            classes={{
              label: rightChipLabel.length > 8 ? 'labelChipSmall' : 'labelChipMedium'
            }}
          />
        </Grid>}
      </Grid>
    </div>
  );
};
